<template>
  <div class="v2-grid v2-grid-cols-2 v2-gap-3">
    <V2Button
      variant="outline"
      block
      :disabled="!isTermsAccepted || isPlacingOrder || localCartProductHasErrors"
      @click="onClickSelectStoresAndPlaceOrder"
    >
      <template v-if="!isPlacingOrder">
        Select stores & place Order
      </template>
      <V2Spinner
        v-else
        size="sm"
      />
    </V2Button>
    <V2Button
      variant="primary"
      block
      :disabled="!isTermsAccepted || isPlacingOrder || localCartProductHasErrors"
      @click="onClickPlaceOrder"
    >
      <template v-if="!isPlacingOrder">
        Place Order for all stores
      </template>
      <V2Spinner
        v-else
        size="sm"
      />
    </V2Button>
  </div>
</template>

<script>
import V2Button from '@/components/v2/V2Button.vue'
import V2Spinner from '@/components/v2/V2Spinner.vue'

export default {
  name: 'V2PlaceOrderButton',
  components: {
    V2Button,
    V2Spinner,
  },
  props: {
    isTermsAccepted: {
      type: Boolean,
      default: false,
    },
    isPlacingOrder: {
      type: Boolean,
      default: false,
    },
    isCartProductHasErrors: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      localCartProductHasErrors: this.isCartProductHasErrors,
    }
  },
  emits: ['on-click-place-order', 'on-click-select-stores-and-place-order'],
  created() {
    this.$store.subscribe((mutation, state) => {
      if (mutation.type === 'setCartHasErrors') {
        this.localCartProductHasErrors = state.checkout.isCartProductHasErrors
      }
    })
  },
  methods: {
    onClickPlaceOrder() {
      this.$emit('on-click-place-order')
    },
    onClickSelectStoresAndPlaceOrder() {
      this.$emit('on-click-select-stores-and-place-order')
    },
  },
}
</script>
